//https://reactjs.org/docs/faq-functions.html
import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import AuthService from "../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import Edit from "@material-ui/icons/Edit";
import { NavLink } from "react-router-dom";

/**
 * Author Darya OREL
 * Page avec tous les mondes
 */

class Worlds extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      thematics: [],
      data: [],
      prevData: [],
      modalAdd: false,
      modalEdit: false,
      idWorldEdit: "",
      nameWorldEdit: "",
      positionWorldEdit: "",
      smilesNeededToUnlockByDefaultWorldEdit: "",
      thematicIdWorldEdit:"",
      title: "",
      smilesNeededToUnlockByDefault: "",
      thematicId: "",
    };

    // edition
    this.edit = this.edit.bind(this);
    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.handleSubmitEditModal = this.handleSubmitEditModal.bind(this);
    this.handleChangeSelectEdit = this.handleChangeSelectEdit.bind(this);


    // suppression
    this.delete = this.delete.bind(this);

    //  changement du select de thématique sur l'ajout
    this.handleChangeSelect = this.handleChangeSelect.bind(this);

    //  changement sur les champs textes
    this.handleChange = this.handleChange.bind(this);

    // Ajout
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * Darya Orel
   * Affichage des messages d'erreurs
   * @param err erreur
   */
  notifyError(err) {
    toast.error(err);
  }

  /**
   * Darya Orel
   * Affichage des messages de success
   * @param msg message
   */
  notifySuccess(msg) {
    toast.success(msg);
  }

  /**
   * Darya Orel
   * Affichage des messages d'erreurs
   * @param err erreur
   */
  notifyInfo(err) {
    toast.info(err);
  }

  /**
   * Alexandre Vasseur
   * Ouverture et fermeture du modal d'ajout
   */
  toggle() {
    this.setState(prevState => ({
      modalAdd: !prevState.modalAdd
    }));
  }

  /**
   * Alexandre Vasseur
   * Ouverture et fermeture du modal d'édition
   */
  toggleEditModal() {
    this.setState(prevState => ({
      modalEdit: !prevState.modalEdit
    }));
  }

  /**
   * Darya Orel
   * Chargement de la page
   * @param err erreur
   */
  componentDidMount() {
    this.fetchWorlds(this);
    this.getThematics(this);
  }

  /**
   * Darya Orel
   * Rechargement de la page
   * @param err erreur
   */
  componentDidUpdate(prevProps) {
    if (prevProps.newFetch !== this.props.newFetch) {
      this.fetchWorlds(this);
      this.forceUpdate();
      this.getThematics(this);
    }
  }

  /**
   * Alexandre Vasseur
   * Récuperation du changement du champ
   */
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }


  /**
   * Alexandre Vasseur
   * Récuperation du changement du champ du select de l'édition
   */
  handleChangeSelectEdit() {
    var e = document.getElementById("thematicIdEdit");
    var value = e.options[e.selectedIndex].value;
    this.setState({
      thematicId: value
    });
  }

  /**
   * Alexandre Vasseur
   * Récuperation du changement du champ du select
   */
  handleChangeSelect() {
    var e = document.getElementById("thematicId");
    var value = e.options[e.selectedIndex].value;
    this.setState({
      thematicId: value
    });
  }

  /**
   * Darya Orel
   * Récuperation de tous les mondes
   */
  fetchWorlds(thus) {
    thus.Auth.httpRequest("GET", "api/world/selectAll")
      .then(function(datas) {
        if (Array.isArray(datas.data) || datas.data.length > 0) {
          thus.setState({
            data: datas.data
          });
        }
      })
      .catch(error => this.notifyError("Erreur de récuperation des mondes"));
  }

  /**
   * Alexandre Vasseur
   * Récuperation de toutes les thématiques
   */
  getThematics(thus) {
    thus.Auth.httpRequest("get", "api/thematic/selectAll")
      .then(datas => {
        if (Array.isArray(datas.data) || datas.data.length > 0) {
          thus.setState({
            thematics: datas.data
          });
        }
      })
      .catch(error => {
        this.notifyError("Erreur de récuperation des mondes");
      });
  }

  /**
   * Alexandre Vasseur
   * Edition d'un monde
   */
  edit(event) {
    this.setState({
      idWorldEdit: event.currentTarget.getAttribute("data-id"),
      title: event.currentTarget.getAttribute("data-title"),
      smilesNeededToUnlockByDefault: event.currentTarget.getAttribute("data-smilesNeededToUnlockByDefault"),
      thematicId: event.currentTarget.getAttribute("data-thematicId")
    });
    this.toggleEditModal();
    event.preventDefault();
  }

  /**
   * Alexandre Vasseur
   * Suppression d'un monde
   */
  delete(event) {
    let idToDelete = event.currentTarget.getAttribute("data-id");
    let titleToDelete = event.currentTarget.getAttribute("data-title");

    if (
      confirm(
        "Etes-vous sur de bien vouloir supprimer le monde : " + titleToDelete
      )
    ) {
      this.Auth.httpRequest(
        "delete",
        "api/world/delete?id=" +
          idToDelete
      )
        .then(datas => {
          var msg = "Le monde a été supprimé avec succès";
          this.notifySuccess(msg);
        })
        .catch(error => {
          this.notifyError("Erreur de suppression du monde");
        })
        .finally(() => {
          this.fetchWorlds(this);
        });
    }
    event.preventDefault();
  }

  /**
   * Alexandre Vasseur
   * Action lorsqu'on a cliquer sur le submit du modal d'ajout
   */
  handleSubmit(event) {
    this.Auth.httpRequest("POST", "api/world/insert", {
      title: this.state.title,
      thematicId: this.state.thematicId,
      smilesNeededToUnlockByDefault: this.state.smilesNeededToUnlockByDefault
    })
      .then(datas => {
        var msg = "L'ajout du monde a été réalisé avec succès";
        this.notifySuccess(msg);
        this.setState({
          modalAdd: false,
          thematicId: "",
          title: "",
          smilesNeededToUnlockByDefault: ""
        });
      })
      .catch(error => {
        this.notifyError("Erreur d'insertion du monde");
      })
      .finally(() => {
        this.fetchWorlds(this);
      });
    //  on soumet pas vraiment le formulaire
    event.preventDefault();
  }

  /**
   * Alexandre Vasseur
   * Action lorsqu'on a cliquer sur le submit du modal d'édition
   */
  handleSubmitEditModal(event) {
    this.Auth.httpRequest("POST", "api/world/update", {
      id: this.state.idWorldEdit,
      title: this.state.title,
      thematicId: this.state.thematicId,
      smilesNeededToUnlockByDefault: this.state.smilesNeededToUnlockByDefault
    })
      .then(datas => {
        var msg = "La modification du monde a été réalisée avec succès";
        this.notifySuccess(msg);
        this.setState({
          modalEdit: false,
          smilesNeededToUnlockByDefaultWorldEdit: "",
          world:"",
          title:""
        });
      })
      .catch(error => {
        this.notifyError("Erreur de modification du monde");
      })
      .finally(() => {
        this.fetchWorlds(this);
      });
    event.preventDefault();
  }

  /**
   * Darya Orel
   * Render fonction
   * @return la page à afficher
   */
  render() {
    let content, addWorldModal, editWorldModal;

    content = (
      <CardBody className="pb-0">
        <ToastContainer />
        <Table responsive striped bordered>
          <thead>
            <tr>
              <th>Id</th>
              <th>Nom</th>
              <th>Nombre de sourires</th>
              <th>Thématique</th>
              <th>Ressources</th>
              <th>Editer</th>
              <th>Supprimer</th>
            </tr>
          </thead>
          <tbody>
            {this.state.data && this.state.data.length > 0 ? (
              this.state.data.map((object, index) => {
                return (
                  <tr key={index}>
                    <td>{object.id}</td>
                    <td>{object.title}</td>
                    <td>{object.smilesNeededToUnlockByDefault}</td>
                    <td>{object.thematicId}</td>
                    <td>
                      <NavLink exact to={"/admin/WorldResources/" + object.id}>
                        <i className="fa fa-gift" />
                      </NavLink>
                    </td>
                    <td>
                        <a
                          href="#"
                          onClick={this.edit}
                          data-id={object.id}
                          data-title={object.title}
                          data-smilesNeededToUnlockByDefault={object.smilesNeededToUnlockByDefault}
                          data-thematicId={object.thematicId}
                        >
                          <Edit />
                        </a>
                    </td>
                    <td><a href="#" onClick={this.delete} data-title={object.title} data-id={object.id}><i className="fa fa-trash text-danger" /></a></td>
                  </tr>
                );
              })
            ) : (
              <tr />
            )}
          </tbody>
        </Table>
      </CardBody>
    );

    addWorldModal = (
      <div>
        <Modal
          isOpen={this.state.modalAdd}
          toggle={this.toggle}
          className="addWorldModal"
        >
          <form onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle}>Ajouter un monde</ModalHeader>
            <ModalBody>
              <div>
                <label>Nom du monde:</label>
                <br />
                <input
                  required
                  type="text"
                  id="title"
                  name="title"
                  value={this.state.title}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <label>Thematique associée:</label>
                <br />
                <select required onChange={this.handleChangeSelect} id="thematicId">
                  <option hidden>Choissisez la thématique</option>
                  {this.state.thematics.map(object => {
                    return (
                        <option key={object.id} value={object.id}>
                          {object.title}
                        </option>
                    );
                  })}
                </select>
              </div>
              <div>
                <label>Nombre de sourires pour y accéder:</label>
                <br />
                <input
                  required
                  type="text"
                  id="smilesNeededToUnlockByDefault"
                  name="smilesNeededToUnlockByDefault"
                  value={this.state.smilesNeededToUnlockByDefault}
                  onChange={this.handleChange}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Ajouter
              </Button>{" "}
              <Button color="secondary" onClick={this.toggle}>
                Annuler
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );

    editWorldModal = (
      <div>
        <Modal
          isOpen={this.state.modalEdit}
          toggle={this.toggleEditModal}
          className="editWorldModal"
        >
          <form onSubmit={this.handleSubmitEditModal}>
            <ModalHeader toggle={this.toggleEditModal}>
              Modifier un monde
            </ModalHeader>
            <ModalBody>
              <div>
                <h2>{this.state.nameWorldEdit}</h2>
                <div>
                  <label>Nom du monde:</label>
                  <br />
                  <input
                    required
                    type="text"
                    id="title"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div>
                <label>Thematique associée:</label>
                <br />
                <select required onChange={this.handleChangeSelectEdit} id="thematicIdEdit" defaultValue={this.state.thematicId}>
                  <option hidden>Choissisez la thématique</option>
                  {this.state.thematics.map(object => {
                    return (
                        <option key={object.id} value={object.id}>
                          {object.title}
                        </option>
                    );
                  })}
                </select>
              </div>
              <div>
                <label>Nombre de sourires pour y accéder:</label>
                <br />
                <input
                  required
                  type="text"
                  id="smilesNeededToUnlockByDefault"
                  name="smilesNeededToUnlockByDefault"
                  value={this.state.smilesNeededToUnlockByDefault}
                  onChange={this.handleChange}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Modifier
              </Button>{" "}
              <Button color="secondary" onClick={this.toggleEditModal}>
                Annuler
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );

    return (
      <div>
        <div className="animated fadeIn">
          <br />
          <Row>
            <Col xs="12" lg="12">
              <Card>
                <CardHeader>
                  <i className="fa fa-align-justify" /> Mondes

                  <Button
                    className="pull-right"
                    color="primary"
                    onClick={this.toggle}
                  >
                    <i className="fa fa-plus" /> Ajouter
                  </Button>
                </CardHeader>
                {content}
              </Card>
            </Col>
          </Row>
          {addWorldModal}
          {editWorldModal}
        </div>
      </div>
    );

  }
}

export default Worlds;



// WEBPACK FOOTER //
// ./src/views/Worlds/Worlds.js